/* sb-dc-plainwords.js - say it the way a customer would. 2026-09-12 (v4).

   Reported (feedback item 5): the editor shows print-shop vocabulary -
   "Producible: Orderable", "Viewing distance - min text 1.5\"", "Background
   contrast 18.3:1", "CMYK mix - ICC conversion", "Preflight passed". None of
   it means anything to someone buying a banner.

   WHAT THIS DOES: swaps those phrases for plain English in the DOM text. It
   is wording only - no logic, no thresholds, no checks are changed.

   THREE FAULTS FIXED ALONG THE WAY, all found on the live page:
     v1 re-scanned on a 900ms throttle. The app rewrites these panels
     constantly, so wording alternated - reported as "it keeps blinking".
     v2 moved to requestAnimationFrame, which does not run while the tab is in
     the background: measured passes stuck at 1, nothing swapped after the
     first paint.
     v3 used a short timer and only walked what changed - and the viewing
     distance row STILL flickered, because that row is not the app's. It is
     drawn by our own assets/sb-dc-viewfold.js, which rewrites the heading and
     the summary every 400ms whenever they differ from what it expects. Two of
     our own scripts were undoing each other several times a second.
     v4 removes those two entries. That row's wording now lives in
     sb-dc-viewfold.js, where it is written once and never fought over.
     RULE OF THUMB: if a phrase is produced by one of our own sb-dc-* files,
     fix the wording in that file - do not translate it after the fact here.

   The feedback loop (our write -> observer -> our write) is cut two ways: the
   observer is disconnected while we edit, and a pass over unchanged text
   changes nothing and queues nothing.

   Deliberately NOT touched: the font size box ("8.68" with no unit) and
   anything inside an input, textarea or contenteditable - rewriting a field
   while the customer types is how you lose what they typed.

   Numbers inside a phrase are kept: "Background contrast 18.3:1" becomes
   "Text stands out from the background (18.3:1)", so support can still read
   the figure off a screenshot.

   Diagnostics: window.__dcPlainWords() */
(function () {
  'use strict';

  var DELAY = 50;
  var info = { passes: 0, swaps: 0, queued: 0, why: '' };
  window.__dcPlainWords = function () { return info; };

  /* longest first, so a phrase is not half-swapped by a shorter rule.
     "Viewing distance" and "min text" are deliberately absent - see the v4
     note above; they belong to sb-dc-viewfold.js. */
  var MAP = [
    [/\bCMYK\s*mix\s*[\u00b7\u2022\-]\s*ICC\s*conversion\b/gi, 'Colours converted for printing'],
    [/\bICC\s*conversion\b/gi, 'converted for printing'],
    [/\bCMYK\s*mix\b/gi, 'print colours'],
    [/\bBackground\s*contrast\s*([\d.]+)\s*:\s*1\b/gi, 'Text stands out from the background ($1:1)'],
    [/\bBackground\s*contrast\b/gi, 'Text vs background'],
    [/\bPreflight\s*passed\b/gi, 'Ready to print'],
    [/\bPreflight\b/gi, 'Print check'],
    [/\bProducible\b/gi, 'Print check'],
    [/\bNot\s*orderable\b/gi, 'Not ready to order'],
    [/\bOrderable\b/gi, 'Ready to order']
  ];

  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, OPTION: 1, NOSCRIPT: 1 };

  function editable(el) {
    for (var n = el; n; n = n.parentElement) {
      if (n.isContentEditable) return true;
      if (SKIP[n.tagName]) return true;
    }
    return false;
  }

  function swap(s) {
    var out = s;
    for (var i = 0; i < MAP.length; i++) out = out.replace(MAP[i][0], MAP[i][1]);
    return out;
  }

  function fixNode(node) {
    var v = node.nodeValue;
    if (!v || v.length > 300) return 0;
    var el = node.parentElement;
    if (!el || editable(el)) return 0;
    var next = swap(v);
    if (next === v) return 0;
    node.nodeValue = next;
    return 1;
  }

  function fixTree(root) {
    if (!root) return 0;
    if (root.nodeType === 3) return fixNode(root);
    if (root.nodeType !== 1) return 0;
    var n = 0;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) n += fixNode(node);
    return n;
  }

  var obs = null, timer = null, queue = [];

  function run() {
    timer = null;
    info.passes++;
    var work = queue;
    queue = [];
    if (obs) obs.disconnect();                 // our own edits must not feed back
    var n = 0;
    try {
      for (var i = 0; i < work.length; i++) n += fixTree(work[i]);
    } catch (e) { info.why = 'error: ' + (e && e.message); }
    info.swaps += n;
    if (obs) obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  function schedule(records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'characterData') queue.push(r.target);
      else {
        for (var j = 0; j < r.addedNodes.length; j++) queue.push(r.addedNodes[j]);
        if (!r.addedNodes.length) queue.push(r.target);
      }
      if (queue.length > 400) break;           // a wholesale re-render; one sweep will do
    }
    if (queue.length > 400) queue = [document.body];
    info.queued = queue.length;
    if (timer) return;
    timer = setTimeout(run, DELAY);
  }

  function start() {
    queue = [document.body];
    run();
    obs = new MutationObserver(schedule);
    obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
